import { createReducer, on } from '@ngrx/store';
import { TableModel } from 'src/app/tinea-components/table/models/input/table-model';
import { ProviderConnectivityActions } from './provider-connectivity.actions';

export const providerConnectivityFeatureKey = 'ProviderConnectivity';

export interface ProviderConnectivityState {
    data: TableModel | undefined;
    errorMessage: string | null;
    loading: boolean;
    hasError: boolean;
}

export const initialStation: ProviderConnectivityState = {
    data: undefined,
    errorMessage: null,
    loading: true,
    hasError: false
};

export const providerConnectivityReducer = createReducer(
    initialStation,
    on(
        ProviderConnectivityActions.fetchSuccess,
        (state, { data }): ProviderConnectivityState => ({
            ...state,
            data,
            loading: false,
            errorMessage: null,
            hasError: false
        })
    ),
    on(ProviderConnectivityActions.searchAll,
        (state, ) => ({
            ...state,
            loading: true,
        })
    ),
    on(ProviderConnectivityActions.fetchFailure,
        (state, {message}) => ({
            ...state,
            errorMessage: message,
            loading: false,
            hasError: true
        })
    )
);
